/**
 * Replay Indicator Component
 *
 * Visual warning banner shown when replay mode is active
 * Prevents confusion between real-time and replayed data
 */

import React, { useState, useEffect } from "react";
import replayService from "./ReplayService";
import "./ReplayIndicator.css";

const ReplayIndicator = () => {
  const [status, setStatus] = useState(() => replayService.getStatus());

  useEffect(() => {
    // Skip if not enabled
    if (!replayService.enabled) return;

    const handleStatusChange = (newStatus) => {
      setStatus({ ...replayService.getStatus(), ...newStatus });
    };

    replayService.onStatusChange = handleStatusChange;

    return () => {
      replayService.onStatusChange = null;
    };
  }, []);

  // Don't render if not enabled or not active
  if (!replayService.enabled || !status.isActive) return null;

  return (
    <div className="replay-indicator-banner">
      <div className="replay-indicator-content">
        <span className="replay-indicator-icon">⚠️</span>
        <span className="replay-indicator-text">
          REPLAY MODE ACTIVE - NOT REAL-TIME DATA
        </span>
        <span className="replay-indicator-speed">{status.speed}x Speed</span>
        <span className="replay-indicator-icon">⚠️</span>
      </div>
    </div>
  );
};

export default ReplayIndicator;
